import { useSelector } from 'hooks/useSelector';
import { noop } from 'lodash';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Item } from 'screens/AssetsScreen/AssetList/Item/Item';
import { AssetListItemContainerProps } from 'screens/AssetsScreen/AssetList/Item/types';
import { OPEN_ASSET, TOGGLE_CHOSEN_ASSET } from 'store/actions';
import {
  selectAssetListItem,
  selectChosenAssetsCount,
  selectIsAssetChosen,
} from 'store/assets/selectors';
import { selectAssetHasChanges } from 'store/changes/selectors';
import { selectOrganisationListItem } from 'store/organisations/selectors';

export const ListItem: React.FC<AssetListItemContainerProps> = ({ id }) => {
  const dispatch = useDispatch();

  const asset = useSelector((state) => selectAssetListItem(state, id));
  const organisation = useSelector(
    (state) =>
      asset && selectOrganisationListItem(state, asset.organisation_id),
  );
  const selected = useSelector((state) => selectIsAssetChosen(state, id));
  const hasChanges = useSelector((state) => selectAssetHasChanges(state, id));
  const chosenCount = useSelector(selectChosenAssetsCount);

  const toggleChosen = React.useCallback(
    () => dispatch(TOGGLE_CHOSEN_ASSET(id)),
    [dispatch, id],
  );

  const openAsset = React.useCallback(
    () => dispatch(OPEN_ASSET(id)),
    [dispatch, id],
  );

  if (!asset || !organisation) return null;

  return (
    <Item
      asset={asset}
      selected={selected}
      organisation={organisation}
      onLongPress={chosenCount ? noop : toggleChosen}
      onPress={chosenCount ? toggleChosen : openAsset}
      onPressThumbnail={toggleChosen}
      hasChanges={hasChanges}
      useLocalThumbnail
    />
  );
};
